import React from 'react';
import { Heart, Droplets, Sun, Moon, Sparkles, AlertCircle, CheckCircle } from 'lucide-react';

const careItems = [
  {
    icon: Droplets,
    title: "Evite água nas primeiras 24h",
    description: "Não molhe os cílios nas primeiras 24 horas após a aplicação para garantir a fixação da cola.",
    color: "bg-blue-50",
    iconColor: "text-blue-400"
  },
  {
    icon: Moon,
    title: "Durma de barriga para cima",
    description: "Evite dormir de bruços ou de lado para não amassar os fios durante a noite.",
    color: "bg-purple-50",
    iconColor: "text-purple-400"
  },
  {
    icon: Sun,
    title: "Evite calor excessivo",
    description: "Saunas, vapor quente e secadores muito próximos podem enfraquecer a cola.",
    color: "bg-orange-50",
    iconColor: "text-orange-400"
  },
  {
    icon: Heart,
    title: "Não esfregue os olhos",
    description: "Seja delicada! Evite coçar ou esfregar os olhos para manter os fios no lugar.",
    color: "bg-pink-50",
    iconColor: "text-pink-400"
  },
  {
    icon: Sparkles,
    title: "Escove diariamente",
    description: "Use a escovinha fornecida para pentear os cílios delicadamente todos os dias.",
    color: "bg-yellow-50",
    iconColor: "text-yellow-500"
  },
  {
    icon: AlertCircle,
    title: "Evite produtos oleosos",
    description: "Demaquilantes e cremes com óleo podem dissolver a cola. Use produtos à base de água.",
    color: "bg-green-50",
    iconColor: "text-green-400"
  }
];

const CareSection = () => {
  return (
    <section id="cuidados" className="section bg-gradient-to-b from-white to-[var(--color-cream)]">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[var(--color-rose-gold)] uppercase tracking-[0.2em] text-sm font-medium">
            Dicas Importantes
          </span>
          <h2 
            className="text-4xl md:text-5xl text-[var(--color-brown-dark)] mt-4 mb-4"
            style={{ fontFamily: 'var(--font-display)' }}
          >
            Cuidados com seus Cílios
          </h2>
          <div className="decorative-line" />
          <p className="text-[var(--color-text-light)] mt-6 max-w-xl mx-auto">
            Siga essas dicas para manter seus cílios lindos por mais tempo 💕
          </p>
        </div>

        {/* Care Cards Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {careItems.map((item, index) => {
            const IconComponent = item.icon;
            return (
              <div
                key={index}
                className={`${item.color} rounded-2xl p-6 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 animate-fade-in-up`}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className={`w-12 h-12 rounded-full bg-white flex items-center justify-center mb-4 shadow-sm`}>
                  <IconComponent className={item.iconColor} size={24} />
                </div>
                <h3 
                  className="text-lg text-[var(--color-brown-dark)] mb-2 font-medium"
                  style={{ fontFamily: 'var(--font-display)' }}
                >
                  {item.title}
                </h3>
                <p className="text-[var(--color-text-light)] text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Pro Tips Box */}
        <div className="mt-12 max-w-3xl mx-auto">
          <div className="bg-[var(--color-rose-gold-light)] bg-opacity-20 rounded-2xl p-8 border border-[var(--color-rose-gold-light)]">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-full bg-[var(--color-rose-gold)] flex items-center justify-center flex-shrink-0">
                <CheckCircle className="text-white" size={24} />
              </div>
              <div>
                <h4 
                  className="text-xl text-[var(--color-brown-dark)] mb-3"
                  style={{ fontFamily: 'var(--font-display)' }}
                >
                  Dica da Jani ✨
                </h4>
                <p className="text-[var(--color-text)] leading-relaxed">
                  A manutenção ideal é entre <strong>15 a 20 dias</strong> para manter seus cílios sempre cheios e lindos! 
                  Não espere cair tudo para fazer a reposição, assim você mantém o visual impecável o tempo todo. 
                  Agende sua manutenção com antecedência! 💖
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareSection;
